module.exports = __webpack_public_path__ + "img/head.120c1577.png";